export function lazyloaderUpdate() {
    // @ts-ignore defined in App.vue
    if(!document.lazyLoadInstance) return;
    console.log('start update lazyloader');
    // @ts-ignore defined in App.vue
    document.lazyLoadInstance.update(); 
}
